import { primary } from "../../../../theme/constants";

const style = {
  box: {
    padding: 2,
    border: "solid",
    borderWidth: 1,
    borderRadius: 1.2,
    borderColor: primary,
  },
};

export default style;
